<div *ngIf="view === ViewType.Numpad">
    <ion-backdrop
        #backdrop
        class="backdrop"
        stopPropagation="true"
        tappable="true"
        (ionBackdropTap)="hide($event)"
    ></ion-backdrop>
</div>
<div *ngIf="view === ViewType.Numpad" class="wrapper" #wrapper>
    <div class="value">
        <span
            *ngIf="pickerType === PickerType.Date; else productValue"
            [ngClass]="{
                'clr-red': isDateBufferComplete && !isValid,
                'clr-gray': !isDateBufferComplete,
            }"
        >
            {{ formattedDateValue }}
        </span>
        <ng-template #productValue>
            <span *ngIf="value.length > 0" [ngClass]="{ 'clr-red': !isValid }">
                {{ value.join("") }}
            </span>
        </ng-template>
    </div>
    <div class="picker-header flex-row flex-just-spc-btwn">
        <span class="w-33 txt-left" (click)="switch(ViewType.Picker)">{{
            "SHARED.PICKER" | translate
        }}</span>
        <span class="w-33" (click)="hide()">{{ "SHARED.CANCEL" | translate }}</span>
        <span class="w-33 txt-right txt-bold" (click)="triggerChange()">OK</span>
    </div>
    <div class="row flex-row flex-just-spc-btwn" *ngFor="let numpadRow of numpadRows">
        <ng-container *ngFor="let rowData of numpadRow">
            <span
                *ngIf="rowData.type === PickerSymbolType.Digit"
                class="col ion-activatable ripple-parent"
                (click)="addToValue(rowData.value)"
            >
                {{ rowData.value }}
                <ion-ripple-effect></ion-ripple-effect>
            </span>
            <span
                *ngIf="rowData.type === PickerSymbolType.Symbols"
                class="col ion-activatable ripple-parent"
                [ngClass]="{ 'symb-key': pickerType === PickerType.Product }"
                (click)="addToValue(rowData.value)"
            >
                {{ rowData.value }}
                <ion-ripple-effect></ion-ripple-effect>
            </span>
            <span
                *ngIf="rowData.type === PickerSymbolType.Clear"
                class="col ion-activatable ripple-parent"
                (click)="removeFromValue()"
            >
                <ion-icon name="backspace"></ion-icon>
                <ion-ripple-effect></ion-ripple-effect>
            </span>
        </ng-container>
    </div>
</div>
